// Nachlieferung — WIR liefern einen Rest nach (E52, 02.11.2026).
//
// Wir schicken, was da ist, als Teilsendung; der Rest geht später
// portofrei hinterher. Ob eine Nachlieferung offen ist, rechnet der
// Server aus Sendungen und Positionen (api/lib/nachlieferung.php) und
// schreibt es an jede Position (`nachlieferung`) und an die Dashboard-
// Zeile. Hier stehen nur Wortlaut und Textbaustein.

export type NachlieferungArt = 'versand' | 'abholung';

/** Die Marke an der Position. */
export const NACHLIEFERUNG_POSITION: Record<NachlieferungArt, string> = {
  versand: 'wird nachgeliefert',
  abholung: 'wird später abgeholt'
};

/** Die Marke an der Bestellung (Dashboard). */
export const NACHLIEFERUNG_BESTELLUNG: Record<NachlieferungArt, string> = {
  versand: 'Nachlieferung offen',
  abholung: 'Rest abholen'
};

export type NachlieferungTitel = { titel: string; autor: string | null };

function nennung(t: NachlieferungTitel): string {
  const autor = t.autor?.trim() ?? '';
  return autor === '' ? `„${t.titel.trim()}“` : `„${t.titel.trim()}“ von ${autor}`;
}

/**
 * Der Satz für den Rechnungs-Vortext in BONUS — Wortlaut des Betreibers
 * (02.11.2026): „Der Titel XYZ von Autor X wird portofrei nachgeliefert."
 * Mehrere Titel in einem Satz. `null`, wenn nichts nachgeliefert wird.
 *
 * Wie beim Vergriffen-Satz: Ein Mensch kopiert und fügt ein; das Tracking
 * schreibt niemandem selbst (Designprinzip 3).
 */
export function nachlieferungText(titel: readonly NachlieferungTitel[]): string | null {
  if (titel.length === 0) return null;
  if (titel.length === 1) return `Der Titel ${nennung(titel[0])} wird portofrei nachgeliefert.`;
  const namen = titel.map(nennung);
  const liste = `${namen.slice(0, -1).join(', ')} und ${namen[namen.length - 1]}`;
  return `Die Titel ${liste} werden portofrei nachgeliefert.`;
}
